// https://gist.github.com/sproogen/147d75db261505e8a558a7fd11a20551

import Vue from 'vue';

const eventBus = new Vue({});

export default eventBus;
